import styled from 'styled-components';
import { variables } from 'variables';

export const CreateTicketStep2SC = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  padding: ${variables.pageContentPadding}px;
  padding-top: 70px;
  width: 100%;
  padding-right: 0;
  padding-bottom: 0;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
`;

export const DepartmentSC = styled.div`
  margin-top: 1em;
  margin-bottom: 2em;
`;

export const Dept = styled.div`
  display: flex;
  margin-top: 1em;
  cursor: pointer;
  margin-left: ${(props) => (props.subdept ? '2em' : '0')};
  h6 {
    margin: 0;
    margin-top: 3px;
    font-weight: bold;
  }
`;

export const SubDept = styled.div`
  display: flex;
  margin-top: 1em;
  align-items: center;
  cursor: pointer;
  i {
    margin-top: 5px;
  }
  h6 {
    margin: 0;
    margin-top: 3px;
    font-weight: bold;
    margin-left: 2px;
    text-transform: capitalize;
  }
`;
